var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1703 11.29L13.4103 7.05001C13.5981 6.8607 13.8537 6.75421 14.1203 6.75421C14.3869 6.75421 14.6425 6.8607 14.8303 7.05001C15.218 7.44005 15.218 8.06997 14.8303 8.46001L11.2903 12L14.8303 15.54C15.218 15.93 15.218 16.56 14.8303 16.95C14.6416 17.1372 14.3861 17.2415 14.1203 17.24C13.8545 17.2415 13.599 17.1372 13.4103 16.95L9.1703 12.71C8.98099 12.5222 8.8745 12.2666 8.8745 12C8.8745 11.7334 8.98099 11.4778 9.1703 11.29Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default ForwardRef;